import type { FeatureBlockContent, HeroContent } from './types';

export const accountsHero: HeroContent = {
  title: 'Your global USD, EUR & GBP Account',
  cta: { label: 'Get the app', href: '/get-the-app' },
  image: {
    src: '/images/accounts/hero.jpg',
    webpSrc:
      '/images/accounts/hero-960.webp 960w, /images/accounts/hero-1680.webp 1680w, /images/accounts/hero-2800.webp 2800w',
    mobileWebpSrc: '/images/accounts/hero-mobile.webp',
    sizes: '(max-width: 767px) calc(100vw - 40px), min(1680px, calc(100vw - 40px))',
    width: 2800,
    height: 1600,
    alt: 'Friends sharing a moment, with nsave multi-currency balances',
  },
};

export const accountsReceive: FeatureBlockContent = {
  title: 'Receive',
  image: {
    src: '/images/accounts/receive.jpg',
    webpSrc: '/images/accounts/receive-700.webp 700w',
    sizes: '(min-width: 1024px) 700px, calc(100vw - 40px)',
    width: 700,
    height: 720,
    alt: 'Family receiving money on nsave',
  },
  rows: [
    {
      icon: 'flag-usd',
      title: 'USD Transfers',
      description:
        'Get your own ACH and Wire details and receive payments from employers, clients and platforms in USD.',
    },
    {
      icon: 'flag-gbp',
      title: 'GBP Transfers',
      description:
        'Get paid by UK companies and clients quickly and reliably, via wire or faster payments (FPS).',
    },
    {
      icon: 'flag-eur',
      title: 'EUR Transfers',
      description:
        'Receive EUR payments with your own IBAN over SEPA. Accept salaries, invoices and transfers from across Europe.',
    },
  ],
};

export const accountsTransfer: FeatureBlockContent = {
  title: 'Transfer',
  image: {
    src: '/images/accounts/transfer.jpg',
    webpSrc: '/images/accounts/transfer-700.webp 700w, /images/accounts/transfer-1400.webp 1400w',
    sizes: '(min-width: 1024px) 700px, calc(100vw - 40px)',
    width: 2100,
    height: 2160,
    alt: 'Choosing a country to send money to on nsave',
  },
  rows: [
    {
      icon: 'shuffle',
      title: 'Send money home',
      description:
        'Send money home to local PKR, BDT, EGP, SYP and many more bank accounts or mobile wallets.',
      link: { label: 'Try the calculator', href: '/send-money-home' },
    },
    {
      icon: 'bank',
      title: 'Bank transfers',
      description: 'Send USD, EUR and GBP straight to any bank account, at home or abroad.',
    },
    {
      icon: 'coin',
      id: 'stablecoin-wallet',
      title: 'Transfer to a stablecoin wallet',
      description: 'Off-ramp your balance on-chain and send it anywhere, anytime.',
    },
  ],
};

export const accountsConvert: FeatureBlockContent = {
  title: 'Convert',
  image: {
    src: '/images/accounts/convert.jpg',
    webpSrc: '/images/accounts/convert-700.webp 700w, /images/accounts/convert-1400.webp 1400w',
    sizes: '(min-width: 1024px) 700px, calc(100vw - 40px)',
    width: 1400,
    height: 1440,
    alt: 'Converting currencies in the nsave app',
  },
  rows: [
    {
      icon: 'shuffle',
      title: 'Convert between your USD, GBP & EUR accounts',
      description: 'Switch between your balances instantly, whenever the rate suits you.',
    },
    {
      icon: 'star',
      title: '24/7 Conversion',
      description: 'Convert any time, day or night, even when the markets are closed.',
    },
    {
      icon: 'percent',
      title: 'Great rates, low fees',
      description: 'The real exchange rate with one transparent fee and no hidden spread.',
    },
  ],
};
